import React, {
  createContext, useContext, useState,
} from 'react';
import PropTypes from 'prop-types';

const NavContext = createContext(null);

export function NavContextProvider({ children }) {
  const [pageCollectionType, setPageCollectionType] = useState(null);
  return (
    <NavContext.Provider
      value={{
        pageCollectionType,
        setPageCollectionType,
      }}
    >
      {children}
    </NavContext.Provider>
  );
}

NavContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export function useNavContext() {
  const context = useContext(NavContext);

  if (!context) {
    throw new Error('useNavContext must be called from a NavContextProvider');
  }

  return context;
}
